/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputEwFrequencySuggestion } from './OutputEwFrequencySuggestion';
import {
    OutputEwFrequencySuggestionFromJSON,
    OutputEwFrequencySuggestionFromJSONTyped,
    OutputEwFrequencySuggestionToJSON,
} from './OutputEwFrequencySuggestion';

/**
 * 
 * @export
 * @interface OutputEwFrequencySuggestions
 */
export interface OutputEwFrequencySuggestions {
    /**
     * 
     * @type {Array<OutputEwFrequencySuggestion>}
     * @memberof OutputEwFrequencySuggestions
     */
    popular?: Array<OutputEwFrequencySuggestion>;
    /**
     * 
     * @type {Array<OutputEwFrequencySuggestion>}
     * @memberof OutputEwFrequencySuggestions
     */
    presets?: Array<OutputEwFrequencySuggestion>;
}

/**
 * Check if a given object implements the OutputEwFrequencySuggestions interface.
 */
export function instanceOfOutputEwFrequencySuggestions(value: object): boolean {
    return true;
}

export function OutputEwFrequencySuggestionsFromJSON(json: any): OutputEwFrequencySuggestions {
    return OutputEwFrequencySuggestionsFromJSONTyped(json, false);
}

export function OutputEwFrequencySuggestionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputEwFrequencySuggestions {
    if (json == null) {
        return json;
    }
    return {
        
        'popular': json['popular'] == null ? undefined : ((json['popular'] as Array<any>).map(OutputEwFrequencySuggestionFromJSON)),
        'presets': json['presets'] == null ? undefined : ((json['presets'] as Array<any>).map(OutputEwFrequencySuggestionFromJSON)),
    };
}

export function OutputEwFrequencySuggestionsToJSON(value?: OutputEwFrequencySuggestions | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'popular': value['popular'] == null ? undefined : ((value['popular'] as Array<any>).map(OutputEwFrequencySuggestionToJSON)),
        'presets': value['presets'] == null ? undefined : ((value['presets'] as Array<any>).map(OutputEwFrequencySuggestionToJSON)),
    };
}

